import React from 'react';
import NumberFormat from 'react-number-format';
import {
  clearSpecialCharacters,
  isEmpty,
  validateEmail,
  validatePhone,
} from '../../utils/utils';

class NowInput extends React.Component {
  static defaultProps = {
    isNumberFormat: false,
    disable: false,
  };

  render() {
    const {
      isNumberFormat,
      numberFormatProps,
      disable,
      value,
      onChange,
      className = '',
      required = false,
      email = false,
      phone = false,
      type = 'text',
      ...rest
    } = this.props;
    const requiredValue = required && isEmpty(value);
    const requiredPhone =
      phone && !isEmpty(value) && !validatePhone(clearSpecialCharacters(value));
    const requiredEmail = email && !isEmpty(value) && !validateEmail(value);
    const requiredClass =
      requiredValue || requiredPhone || requiredEmail ? 'form-required' : '';
    return !isNumberFormat ? (
      <input
        type={type}
        className={`form-control ${className} ${requiredClass}`}
        value={value}
        onChange={onChange}
        disabled={disable}
        {...rest}
      />
    ) : (
      <NumberFormat
        className={`form-control ${className} ${requiredClass}`}
        value={value}
        onValueChange={(values) => {
          onChange({
            target: {
              value: values.value,
            },
          });
        }}
        thousandSeparator="."
        decimalSeparator=","
        disabled={disable}
        {...numberFormatProps}
        {...rest}
      />
    );
  }
}

export default NowInput;



// WEBPACK FOOTER //
// ./foody/src/components/Common/NowInput.jsx